export enum PieceColor {
    RED,
    BLUE,
    PURPLE,
    YELLOW,
    GREEN,
    ORANGE
}